import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const secondaryLinkDivider = (theme: Theme) => css`
  ${breakpoint.up('sm')} {
    width: 1px;
    align-self: stretch;
    background-color: ${theme.palette.neutral[200]};
  }
`

export const icon = css`
  margin-right: ${size[8]};
`

export const secondaryContainer = css`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: clamp(${size[16]}, 1.5vw + ${size[8]}, ${size[32]});
  flex-shrink: 0;
  margin: 0;
  padding: 0;

  & > * {
    flex-shrink: 0;
  }
`

export const secondaryButton = css`
  a {
    height: 50px;
  }

  ${breakpoint.down('smMd')} {
    a {
      padding: ${size[12]} ${size[20]};
      max-height: ${size[40]};
    }
  }
`
